import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import { grey } from "@material-ui/core/colors";

import { date, hour } from "../../utils/fields/formatters";

const STATUS_MAP = {
  RECUSA: "Pedido Recusado",
  CANCELAR: "Pedido Cancelado",
  CONFIRMACAO_TOTAL: "Confirmação total",
  CONFIRMACAO_PARCIAL: "Confirmação parcial",
  AGUARDANDO_PAGAMENTO: "Aguardando pagamento",
  AGUARDANDO_CONFIRMACAO_PARCIAL: "Aguardando confirmação parcial",
  CONFIRMAR_ENTREGA: "Confirmação da Entrega",
  ENTREGUE: "Pedido entregue",
  DEVOLUCAO: "Pedido Devolvido",
  CONFIRMAR_RECEBIMENTO: "Confirmação do Recebimento",
  VISUALIZADO: "Pedido visualizado",
  EM_SEPARACAO: "Em separação",
  RETORNAR_PARA_ESTOQUE: "Retornado para estoque",
};

const useStyles = makeStyles((theme) => ({
  dialogHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  skeleton: {
    backgroundColor: "#ccc",
  },
  listContent: {
    borderBottom: `1px solid ${grey[200]}`,
    maxHeight: "50vh",
    minWidth: 380,
    minHeight: 130,
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  TableCellHead: {
    fontWeight: "bold",
    color: "#727177",
  },
  TableCellBody: {
    color: "#69696F",
  },
  TableCellBodySuccess: {
    background: "#E6F3E6",
    color: "#003A00",
    padding: "6px 10px",
    borderRadius: "20px",
  },
  TableCellBodyCancel: {
    background: "#FFE6EB",
    color: "#4A000F",
    padding: "6px 10px",
    borderRadius: "20px",
  },
  dialogModal: {
    "& .MuiDialog-paperWidthSm": {
      minWidth: "700px !important",
    },
  },
}));

export default function AssociadosModal(props) {
  const { open, handleClose, data } = props;

  const classes = useStyles();

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        className={classes.dialogModal}
      >
        <div className={classes.dialogHeader}>
          <DialogTitle>
            <b>Auditoria</b>
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className={classes.listContent}>
          <Table>
            <TableHead>
              <TableRow>
                {["Ação", "Data", "Usuário"].map((columnName) => (
                  <TableCell key={columnName} className={classes.TableCellHead}>
                    {columnName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.events &&
                data.events.map((event) => (
                  <TableRow key={event.dataCriacao}>
                    <TableCell className={classes.TableCellBody}>
                      <span
                        className={
                          event.tipo === "RECUSA" ||
                          event.tipo === "CANCELAR" ||
                          event.tipo === "DEVOLUCAO"
                            ? classes.TableCellBodyCancel
                            : classes.TableCellBodySuccess
                        }
                      >
                        {STATUS_MAP[event.tipo]}
                      </span>
                    </TableCell>
                    <TableCell className={classes.TableCellBody}>
                      {date(event.dataCriacao)} {hour(event.dataCriacao)}
                    </TableCell>
                    <TableCell className={classes.TableCellBody}>
                      {event.usuario}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </>
  );
}
